module.exports = __webpack_public_path__ + "img/INTERIOR-S-CROSS-4.a99066ff.jpg";